export default __webpack_public_path__ + "static/EN_Emergency-Kit-ac42ddf424408f320a5c62fdd9cd1e53.svg";